__turbopack_context__.v({
  "fitContent": "jddG9G_fitContent",
  "minContent": "jddG9G_minContent",
  "modal": "jddG9G_modal",
});
